// Ausgangsbilanz eines Modellunternehmens in t CO2e pro Jahr.
export const SCOPE12_SOURCES = ["power", "heat", "fleet"]

export function baselineSources(data, industryKey, employees) {
  const profile = data.industries.industries[industryKey]
  if (!profile) throw new Error(`Unbekannte Branche: ${industryKey}`)
  const ef = data.industries.energy_factors
  const purchases = profile.revenue_per_employee * profile.purchase_ratio
  const categories = data.factors.categories
  const tonnes = (eur, factor) => (eur * factor) / 1000

  const perEmployee = {
    power: (profile.power_kwh * ef.power_kg_per_kwh) / 1000,
    heat: (profile.heat_kwh * ef.heat_kg_per_kwh) / 1000,
    fleet: (profile.fleet_litre * ef.fleet_kg_per_litre) / 1000,
    logistics: tonnes(purchases * profile.logistics_ratio, categories.logistics.kg_co2e_per_eur),
    travel: tonnes(profile.travel_eur * 0.7, categories.air_travel.kg_co2e_per_eur) +
      tonnes(profile.travel_eur * 0.3, categories.hotels.kg_co2e_per_eur),
    commute: profile.commute_t,
    use_phase: profile.use_phase_t,
    end_of_life: profile.end_of_life_t,
    waste: profile.waste_t
  }
  for (const [category, share] of Object.entries(profile.purchase_split)) {
    perEmployee[category] = tonnes(purchases * share, categories[category].kg_co2e_per_eur)
  }

  const sources = {}
  for (const [key, value] of Object.entries(perEmployee)) sources[key] = value * employees
  return sources
}

// Leitet Vorkettenemissionen (Kat. 3) und Summen je Station und Scope ab.
export function summarize(data, sources) {
  const all = { ...sources }
  const scope12 = SCOPE12_SOURCES.reduce((sum, key) => sum + (all[key] || 0), 0)
  all.upstream_energy = scope12 * data.industries.energy_factors.upstream_energy_share

  const stations = {}
  for (const [id, station] of Object.entries(data.stations.stations)) {
    stations[id] = station.sources.reduce((sum, key) => sum + (all[key] || 0), 0)
  }
  const total = Object.values(all).reduce((sum, value) => sum + value, 0)
  const scope3 = total - scope12
  return { sources: all, stations, scope12, scope3, total, scope3Share: total > 0 ? scope3 / total : 0 }
}

export function baseline(data, industryKey, employees) {
  return summarize(data, baselineSources(data, industryKey, employees))
}
